import { useCallback, useMemo, useRef } from "react";
import { f7 } from "framework7-react";
import { escapeHtml } from "../utils/escape-html";

export const useToast = () => {
  const toastRef = useRef(null);

  const showToast = useCallback(
    ({ text, closeTimeout = 800, cssClass = "", buttonText, on }) => {
      if (!text) return null;

      // Close (not destroy) a toast that is still open: destroying it while
      // open makes its close timer throw and leaves the modal stuck.
      if (toastRef.current?.opened) {
        toastRef.current.close();
      }

      toastRef.current = f7.toast.create({
        text: escapeHtml(text),
        closeTimeout,
        cssClass,
        destroyOnClose: true,
        ...(buttonText
          ? { closeButton: true, closeButtonText: escapeHtml(buttonText) }
          : {}),
        ...(on ? { on } : {}),
      });
      toastRef.current.open();
      return toastRef.current;
    },
    [],
  );

  const showError = useCallback(
    (text) => showToast({ text, cssClass: "color-red", closeTimeout: 2000 }),
    [showToast],
  );

  const showInfo = useCallback(
    (text) => showToast({ text, closeTimeout: 1500 }),
    [showToast],
  );

  return useMemo(
    () => ({ showToast, showError, showInfo }),
    [showToast, showError, showInfo],
  );
};
